import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent } from 'mbs-ui-kit';
import Computer, { AgentType } from 'mbs-ui-shared@models/Computer';
import { ConnectionType, PrepareConnectionMode } from 'mbs-ui-shared@models/ConnectionType';
import { ConnectService } from 'mbs-ui-shared@services/connect.service';
import { delay, filter, map, Observable, take } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mbs-remote-connection-prepare-modal-component',
  templateUrl: './remote-connection-prepare-modal.component.html',
  styleUrls: ['./remote-connection-prepare-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ButtonComponent, NgbTooltipModule, I18NextPipe, ModalComponent]
})
export class RemoteConnectionPrepareModalComponent implements AfterViewInit {
  private cdr = inject(ChangeDetectorRef);
  connectService = inject(ConnectService);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  public downloadLink: string;
  public computer$: Observable<Computer>;
  public connectionType: ConnectionType;
  public connectionMode$: Observable<PrepareConnectionMode>;
  public readonly Type = ConnectionType;
  public readonly PrepareConnectionMode = PrepareConnectionMode;

  readonly autoCloseTimeout = 60000;

  public get isAgentSupportWebRTC$(): Observable<boolean> {
    return this.computer$.pipe(map((computer) => this.connectService.isAgentSupportWebRTC(computer, AgentType.RA)));
  }

  ngAfterViewInit(): void {
    if (this.baseModal.data) {
      this.downloadLink = this.baseModal.data.downloadLink;
      this.computer$ = this.baseModal.data.computer$;
      this.connectionType = this.baseModal.data.connectionType;
      this.connectionMode$ = this.baseModal.data.connectionMode$;
      this.cdr.detectChanges();

      this.connectionMode$
        .pipe(
          filter((mode) => mode === PrepareConnectionMode.Ready),
          take(1),
          delay(this.autoCloseTimeout)
        )
        .pipe(untilDestroyed(this))
        .subscribe(() => this.baseModal.close());
    }
  }

  connect(type: ConnectionType, retry = false) {
    this.computer$.pipe(filter(Boolean), take(1)).subscribe((computer) => {
      this.connectService.startConnect(computer, type, retry);
      type === ConnectionType.WebRTC && retry && this.baseModal.close();
    });
  }
}
